import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useScrollReveal, getRevealStyle } from '@/hooks/useScrollReveal';

const faqItems = [
  {
    q: '機曜文化是什麼品牌？',
    a: '機曜文化（GIYAO）是機曜文化事業有限公司的對外品牌名稱，以科普類書籍為主要出版方向，透過適合一般讀者理解的文字與圖像，呈現自然科學、人體、環境、科技及知識探索等主題。',
  },
  {
    q: '機曜文化與崧博出版是什麼關係？',
    a: '本品牌委託崧博出版經銷，官方網站由崧博出版製作。崧博出版負責通路發行與銷售，機曜文化是具有自身出版定位的出版品牌。',
  },
  {
    q: '在哪裡可以查到機曜文化的完整書目？',
    a: '完整書名、作者、ISBN、出版日期及其他正式書目資訊，請前往崧博書籍資料庫（catalog.sonbook.net）查詢。',
  },
  {
    q: '在哪裡可以購買機曜文化的書籍？',
    a: '讀者可透過博客來等合作通路平台搜尋機曜文化書籍。各作品在不同平台的上架狀態、版本、價格及庫存可能不同，實際資訊請以各通路頁面為準。',
  },
  {
    q: '如何聯絡或洽詢品牌合作？',
    a: '如有機曜文化品牌經銷、通路合作、內容合作、媒體或其他相關合作需求，請直接聯繫崧博出版洽詢。品牌經銷與合作方案詳情請直接聯繫洽詢。',
  },
];

export default function HomeFaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const navigate = useNavigate();
  const { ref, isVisible } = useScrollReveal<HTMLElement>({ threshold: 0.1 });

  return (
    <section
      ref={ref}
      className="min-h-[100svh] flex items-center bg-background-100 border-t border-primary-500/8"
    >
      <div className="w-full max-w-[1280px] mx-auto px-6 md:px-10 py-20 md:py-28">
        {/* Section label */}
        <div
          style={getRevealStyle(isVisible, 0)}
          className="flex items-center justify-center gap-4 mb-12 md:mb-16"
        >
          <span className="text-[10px] font-medium text-primary-400 tracking-[0.25em] uppercase font-label">
            FAQ
          </span>
          <div className="w-12 h-px bg-primary-500/30" />
          <span className="text-[10px] font-medium text-primary-400 tracking-[0.25em] uppercase font-label">
            05
          </span>
        </div>

        {/* Centered heading */}
        <h2
          style={getRevealStyle(isVisible, 60)}
          className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-100 leading-[1.1] tracking-tight text-center text-glow"
        >
          常見問答
        </h2>
        <div
          style={getRevealStyle(isVisible, 100)}
          className="mt-6 w-12 h-0.5 bg-primary-500 mx-auto shadow-[0_0_8px_var(--tw-shadow-color)] shadow-primary-500/40"
        />

        <p
          style={getRevealStyle(isVisible, 120)}
          className="mt-6 text-sm text-foreground-400 leading-[1.9] max-w-[560px] mx-auto text-center"
        >
          關於機曜文化品牌、書籍查詢與合作洽詢。
        </p>

        {/* FAQ list */}
        <div
          style={getRevealStyle(isVisible, 160)}
          className="mt-12 md:mt-16 max-w-[720px] mx-auto"
        >
          <div className="divide-y divide-primary-500/8">
            {faqItems.map((item, i) => (
              <div key={i} className="py-1">
                <button
                  onClick={() => setOpenIndex(openIndex === i ? null : i)}
                  className="w-full flex items-center justify-between py-4 text-left cursor-pointer group"
                >
                  <span className="text-sm font-medium text-foreground-300 pr-6 leading-[1.6] group-hover:text-primary-400 transition-colors">
                    {item.q}
                  </span>
                  <span className={`shrink-0 w-6 h-6 flex items-center justify-center border transition-all duration-200 ${
                    openIndex === i
                      ? 'border-primary-400 text-primary-400'
                      : 'border-primary-500/25 text-foreground-600 group-hover:border-primary-400/50'
                  }`}>
                    <i className={`text-xs transition-transform duration-200 ${openIndex === i ? 'ri-subtract-line' : 'ri-add-line'}`} />
                  </span>
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ${
                    openIndex === i ? 'max-h-48 pb-4' : 'max-h-0'
                  }`}
                >
                  <p className="text-sm text-foreground-400 leading-[1.9] pr-10">
                    {item.a}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* View all */}
        <div
          style={getRevealStyle(isVisible, 220)}
          className="mt-8 flex justify-center"
        >
          <button
            onClick={() => navigate('/faq')}
            className="inline-flex items-center gap-2 text-sm font-medium text-primary-400 border-b border-primary-500/30 pb-0.5 hover:text-primary-300 hover:border-primary-400 transition-colors duration-200 cursor-pointer whitespace-nowrap"
          >
            查看全部問答
            <i className="ri-arrow-right-line text-xs" />
          </button>
        </div>
      </div>
    </section>
  );
}